import { render, staticRenderFns } from "./AppSectionTitle.vue?vue&type=template&id=0af39cab&scoped=true&"
import script from "./AppSectionTitle.vue?vue&type=script&lang=ts&"
export * from "./AppSectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AppSectionTitle.vue?vue&type=style&index=0&id=0af39cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af39cab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VRow,VSpacer})
